<mat-table #dataTable [dataSource]="matData" class="mat-elevation-z4 mt-3">
	<mat-row *matRowDef="let row; columns: tableKeys; let i = index" [ngClass]="{ second: !(i % 2) }"></mat-row>
	<ng-container *ngFor="let item of tableColumns" [matColumnDef]="item.id">
		<mat-footer-cell *matFooterCellDef>
			{{ item.name }}
		</mat-footer-cell>
		<mat-cell *matCellDef="let element">{{ element[item.id] }}</mat-cell>
	</ng-container>
	<mat-footer-row *matFooterRowDef="tableKeys" class="mat-footer-custom"></mat-footer-row>
</mat-table>
